module.exports = __webpack_public_path__ + "media/images/background_offer-520w-1fa2974d.jpg";